import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticlePreview from './components/ArticlePreview';
import SEOArticlesSection from './components/SEOArticlesSection';
import TrustBadges from './components/TrustBadges';
import Footer from './components/Footer';
import SEOTextSection from './components/SEOTextSection';
import JsonLd from '@/components/base/JsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://oopbuyspread.pics';
const LOGO_URL = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/5133451b25e408e4a25e4df97e05add8.jpeg';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'OOPBuy Spreadsheet',
  url: SITE_URL,
  description: 'OOPBuy Spreadsheet - Dein umfassender Guide für Sneaker, Kleidung und Accessoires. Alle Kategorien, Sicherheitstipps und Buying Guides für den deutschen Markt.',
  inLanguage: 'de',
  publisher: {
    '@type': 'Organization',
    name: 'OOPBuy Spreadsheet',
    url: SITE_URL,
    logo: {
      '@type': 'ImageObject',
      url: LOGO_URL,
    },
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <Navbar />
      <JsonLd data={homeJsonLd} />
      <main>
        <HeroSection />
        <CategoryGrid />
        <SEOArticlesSection />
        <ArticlePreview />
        <SEOTextSection />
        <TrustBadges />
      </main>
      <Footer />
    </>
  );
}